var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Price.LCLDestinationPortChargesDetails"),
        width: "650px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view pod-charge-form"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { no: "onSubmit", type: "primary" },
                on: { click: _vm.onSubmit }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "onCancel" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
            )
          ],
          1
        ),
        _c("div", { staticStyle: { width: "fit-content" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Source") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "bookingAgent",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": {
                              bookingAgent: true,
                              active: true
                            },
                            "tag-name": "chineseName",
                            "default-value": _vm.price.bookingAgent
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.bookingAgent = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.POL") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pol",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.pol,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pol = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.POD") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pod",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.pod,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pod = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.TradeLane") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "tradeLane",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Region,
                            "custom-label": function(item) {
                              return "" + item.name
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.tradeLane,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.tradeLane = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Carrier") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "carrier",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { seaCmp: true, active: true },
                            "custom-label": function(item) {
                              return (
                                "[" + item.shortName + "]" + item.chineseName
                              )
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.carrier
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.carrier = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.FeeIndex") } },
                      [
                        _c("el-input", {
                          attrs: { no: "feeIndex", maxlength: 10 },
                          model: {
                            value: _vm.price.feeIndex,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "feeIndex", $$v)
                            },
                            expression: "price.feeIndex"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "chargeScaleCode",
                        attrs: {
                          required: "",
                          valid: _vm.$t("FileHistory.PlsInput"),
                          label: _vm.$t("Pricing.FeeName")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "chargeScaleCode",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_ChargeItem,
                            "callback-method-type": "value",
                            "tag-name": "zhName",
                            "tag-value": "scaleCode",
                            "default-value": _vm.price.chargeScaleCode
                          },
                          on: { parentCallBack: _vm.changeSurchargeScaleCode }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "chargeType",
                        attrs: {
                          required: "",
                          valid: _vm.$t("FileHistory.PlsInput"),
                          label: _vm.$t("Pricing.ChargeType")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "chargeType",
                            "static-options": _vm.chargeTypes,
                            "tag-name": "label",
                            clearable: false,
                            "tag-value": "value",
                            "default-value": _vm.price.chargeType
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.chargeType = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ChargeUnit") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "unit",
                            filterable: "",
                            clearable: false,
                            "select-type":
                              _vm.selectTypeNames.basic_data_ChargeUnit,
                            "callback-method-type": "value",
                            "tag-name": "chineseName",
                            "tag-value": "code",
                            "default-value": _vm.price.unit
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.unit = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "payment",
                        attrs: {
                          required: "",
                          valid: _vm.$t("Pricing.PlsSelect"),
                          label: _vm.$t("Pricing.PaymentTerm")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "payment",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$PAYMENT_TERMS,
                            "show-custom-label-in-option": true,
                            clearable: false,
                            "default-value": _vm.price.payment
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.payment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.price.vat,
                              callback: function($$v) {
                                _vm.$set(_vm.price, "vat", $$v)
                              },
                              expression: "price.vat"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Pricing.VatIncluded")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.COST_VAT") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { no: "costVat", type: "number" },
                              on: { change: _vm.costVatChange },
                              model: {
                                value: _vm.costVat,
                                callback: function($$v) {
                                  _vm.costVat = $$v
                                },
                                expression: "costVat"
                              }
                            }),
                            _c("label", [_vm._v(" %")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.SELL_VAT") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { no: "sellVat", type: "number" },
                              on: { change: _vm.sellVatChange },
                              model: {
                                value: _vm.sellVat,
                                callback: function($$v) {
                                  _vm.sellVat = $$v
                                },
                                expression: "sellVat"
                              }
                            }),
                            _c("label", [_vm._v(" %")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.GenerateCharge") } },
                      [
                        _c("el-checkbox", {
                          attrs: { no: "generateCharge" },
                          model: {
                            value: _vm.price.generateCharge,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "generateCharge", $$v)
                            },
                            expression: "price.generateCharge"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        ref: "currency",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.Currency")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "currency",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Currency,
                            clearable: false,
                            "default-value": _vm.price.currency
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.currency = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Cost") } },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: { display: "block" },
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  width: "50%",
                                  display: "inline-block"
                                }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("Pricing.Cost")) + " "
                                )
                              ]
                            ),
                            _c("span", [_vm._v(" Min ")])
                          ]
                        ),
                        _c("numeric-stepper", {
                          staticStyle: { "margin-bottom": "3px" },
                          attrs: {
                            no: "costMin",
                            "show-tact": false,
                            "show-value": _vm.price.costMin,
                            "nil-label": _vm.$t("Price.Empty")
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.costMin = p
                            }
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: { "margin-top": "10px" },
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _c("span", {
                              staticStyle: {
                                width: "50%",
                                display: "inline-block"
                              }
                            }),
                            _c("span", [_vm._v(" Rate ")])
                          ]
                        ),
                        _c("numeric-stepper", {
                          attrs: {
                            no: "costRate",
                            "show-tact": false,
                            "show-value": _vm.price.costRate,
                            "nil-label": _vm.$t("Price.Empty")
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.costRate = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Coloader") } },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: { display: "block" },
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  width: "50%",
                                  display: "inline-block"
                                }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("Pricing.Coloader")) + " "
                                )
                              ]
                            ),
                            _c("span", [_vm._v(" Min ")])
                          ]
                        ),
                        _c("numeric-stepper", {
                          staticStyle: { "margin-bottom": "3px" },
                          attrs: {
                            no: "coloaderMin",
                            "show-tact": false,
                            "show-value": _vm.price.coloaderMin,
                            "nil-label": _vm.$t("Price.Empty")
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.coloaderMin = p
                            }
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: { "margin-top": "10px" },
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _c("span", {
                              staticStyle: {
                                width: "50%",
                                display: "inline-block"
                              }
                            }),
                            _c("span", [_vm._v(" Rate ")])
                          ]
                        ),
                        _c("numeric-stepper", {
                          attrs: {
                            no: "coloaderRate",
                            "show-tact": false,
                            "show-value": _vm.price.coloaderRate,
                            "nil-label": _vm.$t("Price.Empty")
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.coloaderRate = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.DirectCustomer") } },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: { display: "block" },
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  width: "50%",
                                  display: "inline-block"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("Pricing.DirectCustomer")) +
                                    " "
                                )
                              ]
                            ),
                            _c("span", [_vm._v(" Min ")])
                          ]
                        ),
                        _c("numeric-stepper", {
                          staticStyle: { "margin-bottom": "3px" },
                          attrs: {
                            no: "customerMin",
                            "show-tact": false,
                            "show-value": _vm.price.customerMin,
                            "nil-label": _vm.$t("Price.Empty")
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.customerMin = p
                            }
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: { "margin-top": "10px" },
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _c("span", {
                              staticStyle: {
                                width: "50%",
                                display: "inline-block"
                              }
                            }),
                            _c("span", [_vm._v(" Rate ")])
                          ]
                        ),
                        _c("numeric-stepper", {
                          attrs: {
                            no: "customerRate",
                            "show-tact": false,
                            "show-value": _vm.price.customerRate,
                            "nil-label": _vm.$t("Price.Empty")
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.customerRate = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "beginDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.BeginDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "beginDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.beginDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "beginDate", $$v)
                                },
                                expression: "price.beginDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "endDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.EndDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "endDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.endDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "endDate", $$v)
                                },
                                expression: "price.endDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Remarks") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "remarks",
                            type: "textarea",
                            maxlength: 255
                          },
                          model: {
                            value: _vm.price.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "remarks", $$v)
                            },
                            expression: "price.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }